export const STRIPE_TEST_KEY = `${process.env.REACT_APP_STRIPE_TEST_KEY}`;
export const PerPaginationPageData = 25;

export const ROLE = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  CUSTOMER_SUPPORT: 3,
  USER: 4,
};

export const MODULE = {
  SUBSCRIPTION: "subscription",
};

export const MODEL_POPUPCONTENT = {
  SUBSCRIPTION_TERMS: 3,
  ORDER_TERMS: 2,
};
export const SERVICE_TABS = {
  video: "video",
  photo: "photo",
  both: "both",
};

export const ADMIN_STYLE_PROFILE_PAGE_LOCATION_DATA = {
  photoId: null,
  videoId: null,
  userId: null,
  serviceType: null,
  subProjectId: null,
};

export const ADMIN_STYLE_PROFILE_API_TYPE = {
  [SERVICE_TABS.photo]: "style_profile_photo",
  [SERVICE_TABS.video]: "style_profile_video",
  [SERVICE_TABS.both]: "style_profile_both",
};

export const GLOBAL_INFO_MESSAGE = {
  NO_PROJECT_TYPE_FOR_PHOTOGRAPHY:
    "Photography Services are offered as single packages, so project types are not required",
  NO_ADDITIONALLY_EDIT_FOR_PHOTOGRAPHY:
    "Photography Services are offered as single packages, so Addition Edit are not required",
};

// 1 carat = $12.5
export const DOLLAR_RATE_PER_CARAT = 12.5;
export const MAXIMUM_AMOUNT_OF_SUBMIT_IMAGE = 1000;
export const PHOTOGRAPHY_SERVICE_MAX_IMAGE = 700;
export const MAX_ALLOWED_TOTAL_IMAGES_LIMIT =
  MAXIMUM_AMOUNT_OF_SUBMIT_IMAGE + PHOTOGRAPHY_SERVICE_MAX_IMAGE;
export const PHOTOGRAPHY_SERVICE_PACKAGE_PRICE = {
  carat: 14,
  price: 14 * DOLLAR_RATE_PER_CARAT,
};

export const PHOTOGRAPHY_BASIC_RETOUCH_AMOUNT_PER_IMAGE = {
  price: 2.5,
  carat: 0.2,
};
export const PHOTOGRAPHY_CULLING_AMOUNT_PER_IMAGE = {
  price: 0.06,
  // Carat cost per 100-image block
  carat: 0.48,
};

export const STYLE_PROFILE_PARAM_KEYS = { styleProfileTab: "styleProfileTab" };

export const defaultFileUploadSize = 15 * 1024 * 1024;

export const FOOTAGE_TRANSFER_METHOD = {
  online: "online",
  offline: "offline",
};
export const FOOTAGE_TRANSFER_METHOD_OPTIONS = [
  { value: FOOTAGE_TRANSFER_METHOD.online, label: " Dropbox or Google" },
  { value: FOOTAGE_TRANSFER_METHOD.offline, label: "Harddrive" },
];

export const FOOTAGE_UPLOAD_STATUS = {
  fully_uploaded: "fully_uploaded",
  still_uploading: "still_uploading",
};

export const FOOTAGE_UPLOAD_STATUS_OPTIONS = [
  { value: FOOTAGE_UPLOAD_STATUS.fully_uploaded, label: "Fully uploaded" },
  { value: FOOTAGE_UPLOAD_STATUS.still_uploading, label: "Still uploading" },
];

export const AG_GRID_COLUMN_API = {
  VIDEO_PROJECT_MANAGEMENT: 1,
  PHOTO_PROJECT_MANAGEMENT: 12,
};
